import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCapturedTextClicked.meta';

export type UseTrackCapturedTextClickedParams = {
  text_id: string;
  text: string;
};

export const useTrackCapturedTextClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCapturedTextClicked = useCallback(
    (params: UseTrackCapturedTextClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCapturedTextClicked };
};
